// extracted by mini-css-extract-plugin
module.exports = {"main-block__left-menu":"left-menu_main-block__left-menu__mJ7v3","left-menu__write-letter":"left-menu_left-menu__write-letter__1OuYg"};